module.exports = __webpack_public_path__ + "icon-jest.3CIdrHDk.svg";